import React from 'react';


const PasswordStrengthItem = ({ state, color, text }) => {

    return <div className={`${text} color-${color} mr-1 password-strength-item ${state ? 'd-flex' : 'd-none'} `}></div>
}

const PasswordStrengthComponent = ({ easy, average, strong, passwordError }) => {
    const items = {
        easy: {
            text: 'easy',
            color: 'red',
            state: easy,
        },
        average: {
            text: 'average',
            color: 'yellow',
            state: average,
        },
        strong: {
            text: 'strong',
            color: 'green',
            state: strong,
        }
    }

    return (
        <div className={`w-100 d-flex password-strength-container ${passwordError ? 'mt-4 pt-2 mb-1' : ''}`}
        >
            { Object.values(items).map((item, index) => {
                const { text, color, state } = item;

                return <PasswordStrengthItem
                    key={index}
                    text={text}
                    color={color}
                    state={state} />
            })}

        </div>
    )
}

export default PasswordStrengthComponent;